export const IconNodeDefaultPosition = {
  x1: -57,
  y1: 32,
};
